import React, { useState } from "react"
import Dialog from "./dialog"
import store from "../store"
import InputComponent from "./input-component/input-component"
import { useRefreshComponent } from "../utils/use-refresh-component"
import { useStepIndex } from "./step-index-context"
import consts from "shared/consts"


var updateStep = store.updateStore

export default function CompileDialog() {
  var stepIndex = useStepIndex()
  var step = store.steps[stepIndex]

  const [selectedFilePath, setSelectedFilePath] = useState(step.files?.[0]?.path)

  function changeCompilerVersion(e) {
    store.steps[stepIndex].skipAutoUpdateVersion = true
    store.steps[stepIndex].compilerVersion = e
    updateStep()
  }

  var stepIndex = useStepIndex()
  function onX() {
    store.removeResults(stepIndex)
    step.dialogOpen = false
    store.compileStepFilesChanged(stepIndex)
    store.updateStore()
    if(location.pathname.match(consts.SCR_APP_URLS.simulation)) {
      store.updateByte32List()
  }
  }

  store.useRerenderIfChange(() => [
    store.steps[stepIndex].dialogOpen,
    store.steps[stepIndex].validating,
    store.steps[stepIndex].compilationErrors,
    store.steps[stepIndex].validFiles,
    store.steps[stepIndex].mainFile,
    store.steps[stepIndex].mainContract,
    store.steps[stepIndex].compilerSettings,
    store.steps[stepIndex].compilerVersion,
    store.steps[stepIndex].files
  ])

  var refreshComponent = useRefreshComponent()

  return <Dialog open={step.dialogOpen}
  >
    {step.dialogOpen && (
      <div>
        <InputComponent
          skipAutoUpdateVersion={store.steps[stepIndex].skipAutoUpdateVersion}
          skipShowSelectInputMethod
          compilerVersion={store.steps[stepIndex].compilerVersion || ""}
          setCompilerVersion={changeCompilerVersion}
          isLoading={false}
          refreshComponent={refreshComponent}
          files={step.files}
          setFiles={x => { step.files = x; store.updateStore() }}
          mainFile={store.steps[stepIndex].mainFile}
          setMainFile={x => { step.mainFile = x; store.updateStore() }}
          mainContract={store.steps[stepIndex].mainContract}
          // @ts-ignore
          setMainContract={x => {
            //@ts-ignore
            if (x.title) x = x.title;
            store.steps[stepIndex].mainContract = x
            store.updateStore()
          }}
          setSelectedFilePath={(path) => {
            step.validFiles = null
            setSelectedFilePath(path)
            store.updateStore()
          }}
          selectedFilePath={selectedFilePath}
          setCompilerSettings={x => {
            store.steps[stepIndex].compilerSettings = x
            store.updateStore()
          }}
          compilerSettings={store.steps[stepIndex].compilerSettings}
          onX={onX}
          validateBtnLabel={"Save & validate"}
        />
      </div>
    )}
  </Dialog>
}